import React, { Suspense, lazy } from 'react';
import type { CustomField } from '@puckeditor/core';

export type LinkCollectionPickerProps = {
  field: { label?: string };
  name: string;
  value: string | null | undefined;
  onChange: (slug: string) => void;
  readOnly?: boolean;
};

// Both entry points stay lazy: the renderer imports nav-carousel's config, but never needs Apollo.
const LinkCollectionPickerWidget = lazy(() => import('./link-collection-picker-widget'));
const CollectionSummary = lazy(() =>
  import('./link-collection-picker-widget').then((module) => ({ default: module.LinkCollectionSummary }))
);

function LinkCollectionPickerRender(props: LinkCollectionPickerProps): JSX.Element {
  return (
    <Suspense fallback={null}>
      <LinkCollectionPickerWidget {...props} />
    </Suspense>
  );
}

export function LinkCollectionSummary({ slug }: { slug: string }): JSX.Element {
  return (
    <Suspense fallback={slug}>
      <CollectionSummary slug={slug} />
    </Suspense>
  );
}

/** Each Puck array row owns its slug; Puck handles ordering, adding and removing rows. */
export const linkCollectionPickerField: CustomField<string> = {
  type: 'custom',
  label: 'Collection',
  render: LinkCollectionPickerRender as CustomField<string>['render'],
  ai: { exclude: true },
};
